import { SortDirection } from "@codat/orchard-ui/dist/es/components/DataTable/types";
import { createContext, useContext } from "react";

export const PAGE_SIZE_KEY = "COMPANIES_PAGE_SIZE";
export const ORDER_BY_KEY = "COMPANIES_ORDER_BY";
export const ORDER_BY_DIRECTION_KEY = "COMPANIES_ORDER_BY_DIRECTION";

interface LocalStorageContextType {
  pageSize: () => number | undefined;
  setPageSize: (n: number) => void;

  orderBy: () => string | undefined;
  orderByDirection: () => SortDirection | undefined;
  setOrderBy: (s: string) => void;
  setOrderByDirection: (s: SortDirection) => void;
}

const localStorageService = (): LocalStorageContextType => {
  const getString = (key: string): string | undefined => {
    const v = localStorage.getItem(key);
    if (v) {
      if (v === "undefined") {
        return undefined;
      }
      // These are required so the companies request doesn't break now the orderBy select has been removed
      if (v === "Date created") {
        return "created";
      }
      if (v === "A - Z") {
        return "name";
      }
      return v;
    }
  };

  const getNumber = (key: string): number | undefined => {
    const asString = localStorage.getItem(key);

    if (asString) {
      const asNumber = Number.parseInt(asString);

      if (!isNaN(asNumber)) {
        return asNumber;
      }
    }
  };

  const pageSize = () => getNumber(PAGE_SIZE_KEY);
  const setPageSize = (n: number) =>
    localStorage.setItem(PAGE_SIZE_KEY, n.toString());

  const orderBy = () => getString(ORDER_BY_KEY);
  const orderByDirection = () =>
    getString(ORDER_BY_DIRECTION_KEY) as SortDirection;
  const setOrderBy = (s: string) => localStorage.setItem(ORDER_BY_KEY, s);
  const setOrderByDirection = (direction: SortDirection) =>
    localStorage.setItem(ORDER_BY_DIRECTION_KEY, direction ?? "");

  return {
    pageSize,
    setPageSize,
    orderBy,
    orderByDirection,
    setOrderBy,
    setOrderByDirection,
  };
};

export const LocalStorageContext = createContext<LocalStorageContextType>(
  localStorageService()
);

export const useLocalStorage = () => useContext(LocalStorageContext);
